import { Component, Input, OnInit } from '@angular/core';
import { Sensor } from '../sensor';

@Component({
    selector: 'sensor-h1',
    templateUrl: 'sensor-h1.component.html',
    styleUrls: ['./sensor-h1.component.scss']
})
export class SensorH1Component implements OnInit {
    @Input() sensor: Sensor;
    constructor() { }

    ngOnInit() { }
}